export class RepresentativeDetails{

    public Name : string;
    public MobileNumber :string;
    public  Email :string;
    public  ProfilePic :string;
    



}